var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"my-5"},[_c('h1',{staticClass:"text-center"},[_vm._v("در حال انتقال به سایت هستید .....")])])])
}]

export { render, staticRenderFns }